module.exports = __webpack_public_path__ + "files/225df355a68713cd5d2228bf304bc120.svg";